import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Symbol from '../tradingPlanFormComponents/FieldComponents/Symbol';

const useStyles = makeStyles({
  root: {
    fontSize: 10,
  },
});

export default function SymbolTextField({
  focusRef,
  top,
  dispatchTop,
  setPositionDirection,
  finishedRenderingOptionChain,
  setFinishedRenderingOptionChain,
}) {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState(top.symbol);

  //useEffect(() => console.log(" symbol text field mounting"));
  return (
    <>
      <TextField
        className={classes.root}
        autoComplete={false}
        //value={top.symbol}
        //autoFocus
        inputRef={focusRef}
        variant="outlined"
        size="small"
        style={{ backgroundColor: 'white', width: '100%' }}
        onChange={(ev) => setInputValue(ev.target.value)}
        onBlur={(ev) => {
          dispatchTop({ symbol: ev.target.value });
          setPositionDirection('');
          if (finishedRenderingOptionChain && setFinishedRenderingOptionChain) {
            setFinishedRenderingOptionChain(false);
          }
        }}
        label={<Typography style={{ fontSize: 10 }}>Symbol</Typography>}
      >
        <Typography style={{ fontSize: 1 }}>{inputValue}</Typography>
      </TextField>
    </>
  );
}
